import { PluginSetup, R4K }
  from '@leverege/recovr-plugins'

export default {
  install( molten ) {
    PluginSetup.install( molten )

    if ( molten.getConfig( 'r4kEnabled' ) === 'true' ) {
      R4K.install( molten )
    }
  }
}
